import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Box,
} from '@mui/material';
import styles from 'module/checklist/Checklist.module.scss';

interface EventItem {
  id: number;
  eventName: string;
  eventType: string;
  startTime: string;
  endTime: string;
}

interface ViewProps {
  onBack: () => void;
  events: EventItem[];
}

const EventsView: React.FC<ViewProps> = ({ onBack, events }) => {
  return (
    <Paper
      elevation={3}
      className={styles.containerr}
      style={{ padding: '20px', backgroundColor: 'whitesmoke' }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5">Event Details</Typography>
        <Button
          variant="outlined"
          onClick={onBack}
          className={styles.button}
          style={{ backgroundColor: 'rgb(68, 99, 136)', padding: '5px 12px', color: 'white' }}
        >
          Back
        </Button>
      </Box>

      <TableContainer component={Paper} sx={{ maxHeight: '300px', overflowY: 'auto' }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Type</TableCell>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((item) => (
              <TableRow key={item.id}>
                <TableCell>{item.eventName}</TableCell>
                <TableCell>{item.eventType}</TableCell>
                <TableCell>{`${item.startTime} – ${item.endTime}`}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default EventsView;
